import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import Saps2ExampleRows from "../model";
import CribScoreCreate from "../create";
import { useTranslate } from "src/locales";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";

function CribScoreList() {
  const { t } = useTranslate();

  const columns: GridColDef[] = [
    {
      field: "update",
      headerName: t("crib-score.update"),
      width: 150,
      renderCell(params) {
        return (
          <Link to={`edit/${params.row.id}`}>
            <EditIcon color="info" />
          </Link>
        );
      },
    },
    { field: "date", headerName: t("crib-score.date"), flex: 1 },
    { field: "field1", headerName: "Alan 1", flex: 1 },
    { field: "field2", headerName: "Alan 2", flex: 1 },
    { field: "field3", headerName: "Alan 3", flex: 1 },
    { field: "field4", headerName: "Alan 4", flex: 1 },
    { field: "field5", headerName: "Alan 5", flex: 1 },
    {
      field: "delete",
      headerName: t("crib-score.delete"),
      flex: 1,
      renderCell: (params) => (
        <IconButton onClick={() => console.log(params.row.id)}>
          <DeleteIcon color="error" />
        </IconButton>
      ),
    },
  ];

  return (
    <BaseMedCardList
      title={t("crib-score.title")}
      columns={columns}
      rows={Saps2ExampleRows}
      CreateComponent={CribScoreCreate}
      pageSize={10}
    />
  );
}

export default CribScoreList;